import { setStorageTokens } from '@core-frontend/core-frontend';

import { getCookie, setCookie } from '@/shared/lib/cookies';

/**
 * Persist tokens in cookies
 *
 * @param accessToken the access token
 * @param refreshToken the refresh token
 */
export const persistTokens = (accessToken: string, refreshToken: string) => {
  setCookie('access_token', accessToken, 7);
  setCookie('refresh_token', refreshToken, 7);
};

/**
 * Load tokens from cookies into local storage
 * Useful for sharing tokens between subdomains
 *
 * @returns ```{ access_token, refresh_token }``` or ```null```
 */
export const loadTokensFromCookies = () => {
  const accessToken = getCookie('access_token');
  const refreshToken = getCookie('refresh_token');

  if (accessToken && refreshToken) {
    setStorageTokens(accessToken, refreshToken);
    return { accessToken, refreshToken };
  }
  return null;
};
